export default __webpack_public_path__ + "static/media/its-on-fire.972d0a18.gif";